import path from 'path';
import { getExportsFilenames } from '../utils/get-exports-filenames';
export const getCSSFilename = ({ pkg, }) => {
    const filenames = getExportsFilenames(pkg.exports);
    return filenames.find(filename => path.extname(filename) === '.css');
};
